import React from 'react'
import { dataMap } from '@/src/data/Accessories'
import Header from '@/src/components/HeaderV2'
import Footer from '@/src/components/Footer/Footer2'
import Details from '@/src/components/Product/Accessories/Details'
import Video from '@/src/components/Product/Accessories/Video'
import Tips from '@/src/components/Product/Accessories/Tips'

export async function getServerSideProps(context) {
  return { props: context.query }
}

export default function Accessory({ accessory }) {
  const data = dataMap[accessory]

  return (
    <>
      <Header />
      <Details data={data} />
      <Video poster={data.poster} video={data.video} />
      {data.tips && <Tips tips={data.tips} />}
      <Footer />
    </>
  )
}
